
{
  "familyId": "TOPO-EU-GEBERGTE",
  "questions": [
    {
      "id": "TOPO-EU-GEBERGTE-001",
      "familyId": "TOPO-EU-GEBERGTE",
      "module": "Topo",
      "tier": 11,
      "levelCode": "E7",
      "group": 7,
      "skill": "europa",
      "subSkill": "topo_gebergte_eu",
      "questionType": "multiple_choice",
      "question": "Welk gebergte ligt tussen Frankrijk en Spanje?",
      "options": ["De Pyreneeën", "De Alpen", "De Karpaten", "De Ardennen"],
      "correctAnswer": 0,
      "stimulusAids": [],
      "supportAids": [{"type": "rule", "showWhen": "wrong", "data": {"title": "Gebergten in Europa", "content": "De Pyreneeën liggen op de grens van Frankrijk en Spanje. De Alpen liggen in Midden-Europa (Zwitserland, Oostenrijk, Italië, Frankrijk). De Karpaten liggen in Oost-Europa.", "icon": "lightbulb"}}],
      "conceptId": "gebergte_pyreneeën",
      "variantIndex": 1,
      "citoDifficulty": 0.28,
      "citoDiscrimination": 0.76,
      "feedback": {
        "explanationText": "De Pyreneeën vormen de natuurlijke grens tussen Frankrijk en Spanje. Ze lopen van de Atlantische Oceaan tot de Middellandse Zee.",
        "solutionSteps": ["Zoek de grens tussen Frankrijk en Spanje", "Daar liggen de Pyreneeën", "De Alpen liggen meer naar het oosten (Zwitserland)"],
        "distractorExplanations": {
          "0": "Goed! De Pyreneeën liggen op de grens van Frankrijk en Spanje.",
          "1": "Je dacht waarschijnlijk aan de Alpen. Maar de Alpen liggen in Midden-Europa (Zwitserland, Oostenrijk, Italië). Tussen Frankrijk en Spanje liggen de Pyreneeën. Onthoud: Pyreneeën = Frankrijk/Spanje.",
          "2": "Je dacht waarschijnlijk aan de Karpaten. Maar die liggen in Oost-Europa (Roemenië, Slowakije). Onthoud: Karpaten = Oost-Europa, Pyreneeën = Frankrijk/Spanje.",
          "3": "Je dacht waarschijnlijk aan de Ardennen. Maar de Ardennen liggen in België en Luxemburg — dat is veel noordelijker. Onthoud: Ardennen = België, Pyreneeën = Frankrijk/Spanje."
        }
      }
    },
    {
      "id": "TOPO-EU-GEBERGTE-002",
      "familyId": "TOPO-EU-GEBERGTE",
      "module": "Topo",
      "tier": 11,
      "levelCode": "E7",
      "group": 7,
      "skill": "europa",
      "subSkill": "topo_gebergte_eu",
      "questionType": "multiple_choice",
      "question": "De Mont Blanc is de hoogste berg van de Alpen. In welk land ligt deze berg?",
      "options": ["Frankrijk en Italië", "Zwitserland", "Oostenrijk", "Duitsland"],
      "correctAnswer": 0,
      "stimulusAids": [],
      "supportAids": [{"type": "rule", "showWhen": "wrong", "data": {"title": "De Mont Blanc", "content": "De Mont Blanc (4.808 m) is de hoogste berg van de Alpen en van West-Europa. Hij ligt op de grens van Frankrijk en Italië.", "icon": "lightbulb"}}],
      "conceptId": "gebergte_mont_blanc",
      "variantIndex": 2,
      "citoDifficulty": 0.35,
      "citoDiscrimination": 0.73,
      "feedback": {
        "explanationText": "De Mont Blanc (4.808 meter) ligt op de grens van Frankrijk en Italië. Het is de hoogste berg van de Alpen en van West-Europa. 'Mont Blanc' is Frans voor 'witte berg'.",
        "solutionSteps": ["Mont Blanc = hoogste berg van de Alpen", "Ligt op de grens van Frankrijk en Italië", "'Mont Blanc' = Frans voor 'witte berg'"],
        "distractorExplanations": {
          "0": "Goed! De Mont Blanc ligt op de grens van Frankrijk en Italië. De naam is Frans voor 'witte berg'.",
          "1": "Je dacht waarschijnlijk aan Zwitserland. Zwitserland heeft veel Alpentoppen, maar de Mont Blanc ligt op de grens van Frankrijk en Italië. Onthoud: de naam is Frans ('witte berg').",
          "2": "Je dacht waarschijnlijk aan Oostenrijk. Oostenrijk heeft ook Alpen, maar de Mont Blanc ligt westelijker. Onthoud: Mont Blanc = Frankrijk/Italië.",
          "3": "Je dacht waarschijnlijk aan Duitsland. Maar de Duitse Alpen zijn relatief laag. De Mont Blanc ligt veel zuidelijker. Onthoud: de hoogste Alpentoppen liggen in Frankrijk, Italië en Zwitserland."
        }
      }
    },
    {
      "id": "TOPO-EU-GEBERGTE-003",
      "familyId": "TOPO-EU-GEBERGTE",
      "module": "Topo",
      "tier": 11,
      "levelCode": "E7",
      "group": 7,
      "skill": "europa",
      "subSkill": "topo_gebergte_eu",
      "questionType": "multiple_choice",
      "question": "Welk gebergte vormt een natuurlijke grens tussen Europa en Azië?",
      "options": ["De Oeral", "De Karpaten", "De Kaukasus", "De Alpen"],
      "correctAnswer": 0,
      "stimulusAids": [],
      "supportAids": [{"type": "rule", "showWhen": "wrong", "data": {"title": "Grens Europa-Azië", "content": "Het Oeralgebergte in Rusland vormt de traditionele grens tussen Europa en Azië. Het loopt van noord naar zuid door Rusland.", "icon": "lightbulb"}}],
      "conceptId": "gebergte_oeral",
      "variantIndex": 3,
      "citoDifficulty": 0.40,
      "citoDiscrimination": 0.71,
      "feedback": {
        "explanationText": "Het Oeralgebergte in Rusland vormt de traditionele grens tussen Europa en Azië. Het loopt van noord naar zuid, meer dan 2.500 km lang.",
        "solutionSteps": ["Grens Europa-Azië = Oeralgebergte", "Ligt in Rusland", "Loopt van noord naar zuid"],
        "distractorExplanations": {
          "0": "Goed! De Oeral vormt de grens tussen Europa en Azië.",
          "1": "Je dacht waarschijnlijk aan de Karpaten. Maar die liggen in Oost-Europa (Roemenië, Slowakije) — niet op de grens met Azië. Onthoud: Karpaten = Oost-Europa, Oeral = grens Europa/Azië.",
          "2": "Je dacht waarschijnlijk aan de Kaukasus. De Kaukasus ligt ook op de grens van Europa en Azië, maar het Oeralgebergte wordt traditioneel als de hoofdgrens beschouwd. Onthoud: Oeral = de traditionele grens.",
          "3": "Je dacht waarschijnlijk aan de Alpen. Maar de Alpen liggen in het midden van Europa — ver van Azië. Onthoud: Alpen = Midden-Europa, Oeral = grens Europa/Azië."
        }
      }
    },
    {
      "id": "TOPO-EU-GEBERGTE-004",
      "familyId": "TOPO-EU-GEBERGTE",
      "module": "Topo",
      "tier": 11,
      "levelCode": "E7",
      "group": 7,
      "skill": "europa",
      "subSkill": "topo_gebergte_eu",
      "questionType": "multiple_choice",
      "question": "Door welke landen lopen de Karpaten?",
      "options": ["Roemenië, Slowakije en Polen", "Spanje, Frankrijk en Italië", "Noorwegen en Zweden", "Griekenland en Turkije"],
      "correctAnswer": 0,
      "stimulusAids": [],
      "supportAids": [{"type": "rule", "showWhen": "wrong", "data": {"title": "De Karpaten", "content": "De Karpaten zijn een groot gebergte in Oost-Europa. Ze lopen door Roemenië, Slowakije, Polen, Oekraïne en Tsjechië. Het grootste deel ligt in Roemenië.", "icon": "lightbulb"}}],
      "conceptId": "gebergte_karpaten",
      "variantIndex": 4,
      "citoDifficulty": 0.38,
      "citoDiscrimination": 0.72,
      "feedback": {
        "explanationText": "De Karpaten lopen door meerdere Oost-Europese landen: Roemenië (het grootste deel), Slowakije, Polen, Oekraïne en Tsjechië. Het is het op één na langste gebergte van Europa.",
        "solutionSteps": ["Karpaten = Oost-Europees gebergte", "Landen: Roemenië, Slowakije, Polen (+ Oekraïne, Tsjechië)", "Grootste deel in Roemenië"],
        "distractorExplanations": {
          "0": "Goed! De Karpaten lopen door Roemenië, Slowakije en Polen.",
          "1": "Je dacht waarschijnlijk aan de Pyreneeën of Alpen. Maar Spanje, Frankrijk en Italië liggen in West-Europa. De Karpaten liggen in Oost-Europa. Onthoud: Karpaten = Oost-Europa.",
          "2": "Je dacht waarschijnlijk aan de Scandinavische bergen. Maar Noorwegen en Zweden hebben het Scandinavisch Gebergte, niet de Karpaten. Onthoud: Karpaten = Roemenië en omgeving.",
          "3": "Je dacht waarschijnlijk aan het Pindosgebergte of de Taurus. Maar Griekenland en Turkije liggen in Zuid-Europa/Klein-Azië. Onthoud: Karpaten = Oost-Europa (Roemenië, Slowakije, Polen)."
        }
      }
    },
    {
      "id": "TOPO-EU-GEBERGTE-005",
      "familyId": "TOPO-EU-GEBERGTE",
      "module": "Topo",
      "tier": 11,
      "levelCode": "E7",
      "group": 7,
      "skill": "europa",
      "subSkill": "topo_gebergte_eu",
      "questionType": "matching",
      "question": "Koppel elk gebergte aan de juiste ligging.",
      "options": [],
      "correctAnswer": 0,
      "data": {
        "leftItems": ["Alpen", "Pyreneeën", "Karpaten", "Scandinavisch Gebergte"],
        "rightItems": ["Midden-Europa (CH/AT/IT)", "Grens Frankrijk/Spanje", "Oost-Europa (RO/SK/PL)", "Noorwegen/Zweden"],
        "correctMatches": {"0": 0, "1": 1, "2": 2, "3": 3}
      },
      "stimulusAids": [],
      "supportAids": [{"type": "rule", "showWhen": "wrong", "data": {"title": "Gebergten en hun ligging", "content": "Alpen = Midden-Europa (Zwitserland, Oostenrijk, Italië). Pyreneeën = grens Frankrijk/Spanje. Karpaten = Oost-Europa (Roemenië). Scandinavisch Gebergte = Noorwegen/Zweden.", "icon": "lightbulb"}}],
      "conceptId": "gebergte_matching",
      "variantIndex": 5,
      "citoDifficulty": 0.40,
      "citoDiscrimination": 0.70,
      "feedback": {
        "explanationText": "Alpen → Midden-Europa. Pyreneeën → grens Frankrijk/Spanje. Karpaten → Oost-Europa. Scandinavisch Gebergte → Noorwegen/Zweden.",
        "solutionSteps": [
          "Alpen → Midden-Europa (Zwitserland, Oostenrijk, Italië)",
          "Pyreneeën → Grens Frankrijk/Spanje",
          "Karpaten → Oost-Europa (Roemenië, Slowakije, Polen)",
          "Scandinavisch Gebergte → Noorwegen/Zweden"
        ]
      }
    }
  ]
}
